/* istanbul ignore file */
import { Injectable } from '@angular/core';
import { HttpClient, HttpParams, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { PreInitSettingsService } from '../../core/services/settings/pre-init-setting.service';
import { UpdatePaymentDetailsRequest } from '../../model/account/update-payment-details-request';
import { tap } from 'rxjs/operators';
import { GoogleAnalyticsService } from 'src/app/core/services/google-tag-manager.service';
import { GTMApiStatus, GTMEvents } from 'src/app/model/google-tag-manager/api-status';

@Injectable({
  providedIn: 'root'
})
export class BillingProfileDataService {
  private middleWareUrl: string = null;
  private billingPath: string = null;

  constructor(
    private http: HttpClient,
    private preInitSettingsService: PreInitSettingsService,
    public googleAnalyticsService: GoogleAnalyticsService
  ) {
    const settings = this.preInitSettingsService.getSettings();

    this.middleWareUrl = settings.middleWare.middlewareUrl;
    this.billingPath = settings.middleWare.billingPath;
  }

  httpHeaders: HttpHeaders = new HttpHeaders({
    'Accept-Encoding': 'gzip'
  });

  getBillingInfo(zipcode, programCode, contractNumber, clientId, trackingId, associateNumber): Observable<any> {
    const httpOptions = {
      params: new HttpParams()
        .set('zipCode', zipcode)
        .set('programCode', programCode)
        .set('contractId', contractNumber)
        .set('clientId', clientId)
        .set('trackingId', trackingId)
        .set('associateNumber', associateNumber)
    };

    const method = 'paymentprofile';

    return this.http.get<any>(`${this.middleWareUrl}${this.billingPath}${method}`, httpOptions);
  }

  getPaymentInfo(zipcode, programCode, contractNumber, clientId, trackingId, associateNumber): Observable<any> {
    const httpOptions = {
      params: new HttpParams()
        .set('zipCode', zipcode)
        .set('programCode', programCode)
        .set('contractId', contractNumber)
        .set('clientId', clientId)
        .set('trackingId', trackingId)
        .set('associateNumber', associateNumber)
    };

    const method = 'paymentinfo';

    return this.http.get<any>(`${this.middleWareUrl}${this.billingPath}${method}`, httpOptions);
  }

  getPaymentSchedule(zipcode, programCode, contractNumber): Observable<any> {
    const httpOptions = {
      params: new HttpParams()
        .set('zipCode', zipcode)
        .set('programCode', programCode)
        .set('contractId', contractNumber)
    };

    const method = 'paymentschedule';

    return this.http.get<any>(`${this.middleWareUrl}${this.billingPath}${method}`, httpOptions);
  }

  updatePaymentDetails(updatePaymentDetailsRequest: UpdatePaymentDetailsRequest): Observable<any> {
    const method = 'paymentprofile';

    return this.http.put<any>(
      `${this.middleWareUrl}${this.billingPath}${method}`,
      updatePaymentDetailsRequest,
    ).pipe(
      tap({
        complete: () => {
          this.googleAnalyticsService.emitGTMEvent({
            event: GTMEvents.UpdatePayment,
            event_status: GTMApiStatus.Success
          });
        }
      })
    );
  }

  payOverDuePaymentDetails(updatePaymentDetailsRequest: UpdatePaymentDetailsRequest): Observable<any> {
    const method = 'payment';

    return this.http.post<any>(
      `${this.middleWareUrl}${this.billingPath}${method}`,
      updatePaymentDetailsRequest,
    ).pipe(
      tap({
        complete: () => {
          this.googleAnalyticsService.emitGTMEvent({
            event: GTMEvents.MakePayment,
            event_status: GTMApiStatus.Success
          });
        }
      })
    );
  }
}
